import { getKeycloakUserInfo } from "@/services/keycloak";

const groupName = (g: string) => (g.startsWith("/") ? g.slice(1) : g).toLowerCase();

/**
 * Omnimizer mutations need the Keycloak admin or modifier role (require_modifier
 * in the API). This only decides what to offer; the API remains the authority.
 */
function deploymentRoleNames() {
  const info = getKeycloakUserInfo() as
    | { roles?: string[]; groups?: string[]; tokenParsed?: { groups?: string[] } }
    | null;
  if (!info) return [];
  return [
    ...(info.roles || []).map((r) => r.toLowerCase()),
    ...(info.groups || []).map(groupName),
    ...(info.tokenParsed?.groups || []).map(groupName),
  ];
}

export function isAdmin() {
  return deploymentRoleNames().some((n) => n === "admin" || n.endsWith(":admin"));
}

export function canModifyDeployments() {
  return isAdmin() || deploymentRoleNames().includes("modifier");
}
